import PageLayout from "../components/site/PageLayout";
import { SectionHeading } from "../components/site/SectionHeading";

const Terms = () => (
  <PageLayout title="Terms of Use">
    <section className="pt-16 pb-24">
      <div className="container-tt max-w-3xl">
        <SectionHeading eyebrow="Legal" title="Terms of Use" description="Last updated: February 2026" />
        <div className="mt-10 space-y-6 text-stone/85 leading-relaxed">
          <p>By using this website you agree to these simple terms. TechTies is a nonprofit organization operated by student volunteers. The content on this site is provided for informational purposes.</p>
          <h3 className="font-display text-2xl">Use of the site</h3>
          <p>You agree to use this website lawfully and not to attempt to disrupt its normal operation. Content on this site may not be redistributed for commercial purposes without our permission.</p>
          <h3 className="font-display text-2xl">Forms & communication</h3>
          <p>Submitting a form on this site is a request for us to contact you. It does not guarantee acceptance into a program or partnership.</p>
          <h3 className="font-display text-2xl">Liability</h3>
          <p>TechTies makes no warranties about the completeness or accuracy of the content on this site. We are not liable for any damages arising from your use of this website.</p>
          <h3 className="font-display text-2xl">Changes</h3>
          <p>We may update these terms occasionally. The latest version will always be posted on this page.</p>
        </div>
      </div>
    </section>
  </PageLayout>
);
export default Terms;
